/* eslint-disable prettier/prettier */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import Grid from "@techsoftware/happay-widgets/Grid"; 
import Tabs from "@techsoftware/happay-widgets/Tabs";
import { Icons, Button } from '@techsoftware/happay-widgets';
import PropTypes from 'prop-types';
import BalanceListView from '../../containers/billPaymentContainer';
import PaymentInfo from './paymentInfo';
import { CardDetailShimmer } from '../shimmering';
import BillExport from './billExpot'
import Locales from '../../constants/locales';
import NoContent from '../customComponent/noContent';
import NOBALANCE from '../../assets/images/no_bills.svg'
import {
  formatDate,
  currencyFormatter,
  dateDifference,
} from '../../helpers/genericFormator';
import history from '../../utils/history';

const TransactionConstants = Locales.JSON.transactions;

export default class Bill extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      payInfoDialog: false,
    };
    this.tabs = ['previousBalance', 'payments'];
    this.changetoDetailView = this.changetoDetailView.bind(this);
    this.handleDownload = this.handleDownload.bind(this)
  }

  componentDidMount() {
    this.props.getCurrentBalance({});
    this.props.getVirtualAccDetails();
  }

  componentDidUpdate() {
    const { location: { search = '', pathname } = { search: '' } } = history;

    if (search.includes('showPayData')) {
      history.replace(pathname);
      this.setState({ payInfoDialog: true });
    }
  }

  componentWillUnmount(){
    this.props.clearBillStore();
  }

  handleChange = (eve,index) => {
    this.setState({ tab: index });
  };

  changetoDetailView(event) {
    event.stopPropagation();
    const billId = this.props.currentBalance.bill_id;
    history.push({ pathname: `/balancedetail/${billId}` });
  }

  handleDownload(type){
    const {currentBalance} = this.props;
    const query = {
      bill_id: currentBalance.bill_id, 
      offset:0,
      limit:currentBalance.billed_transactions.length,
      type
    }
    this.props.pdfCsvExcelDownload(query);
  }

  getRemainngDaysLogic(date, status, totalAmt) {
    const obj = {
      color: 'blue',
      text: '',
      warningMsg: '',
    };
    if(totalAmt === 0){
      return obj;
    }
    if(status === 'paid'){
      obj.color = 'green';
      obj.text = 'Cleared';
      return obj;
    }if(status === 'carried_over'){
      return obj;
    }

    const remainingDays = dateDifference(new Date(), date);
    if (remainingDays >= 0 && remainingDays <= 2) {
      obj.color = 'orange';
      obj.warningMsg = 'Your bill due date is near. Clear the bill to continue using Happay cards';
      switch(remainingDays){
        case 0:
          obj.text = 'Due date today'
          obj.warningMsg = 'Today is due date. Clear the remaining amount to avoid penalty.'
          break;
        case 1:
          obj.text = `${remainingDays} day remaining`
          break;
        case 2:
          obj.text = `${remainingDays} days remaining`;
          break;
        default:
          break;
      }
    } else if (remainingDays > 2) {
      obj.text = `${remainingDays} days remaining`;
      obj.warningMsg = '';
    } else if (totalAmt > 10){
      obj.color = 'red';
      obj.text = `${remainingDays * -1} day${
        remainingDays === -1 ? '' : 's'
      } overdue`;
      obj.warningMsg =
          'Your bill is overdue and daily penalty is being charged. Pay the remaining amount to avoid penalty';
    }else{
      obj.color = 'blue';
      obj.text = '';
    }
    return obj;
  }

  render() {
    const { tab, payInfoDialog } = this.state;
    const data = this.props.currentBalance || {};
    const remainingDaysObj =
      (data.grace_period_end_date &&
        this.getRemainngDaysLogic(data.grace_period_end_date, data.status, data.remaining_balance)) ||
      {};
    return (
      <Grid xs={24}>
        <Grid
          container
          direction="row"
          justify="space-evenly"
          alignItems="flex-start"
          className={`bordered-container padding-30 margin-b-20 margin-t-20 border-color-${remainingDaysObj.color}`}
        >
          {Object.keys(data).length === 0 ? (
            <CardDetailShimmer />
          ) :
            'error' in data  ? 
              (<Grid
                container
                xs={24}
                justify="center"
                alignItems="center"
              >
                <Grid container item xs={24}  justify="center" alignItems="center">
                  <img src={NOBALANCE} alt="no content" width="150" height="150" />
                </Grid>
                <Grid container item xs={24}  justify="center" alignItems="center" className="body normal text-newline">
                      You have no pending bills currently
                </Grid>
                <Grid container item xs={24}  justify="center" alignItems="center">
                  <Button
                    type="button"
                    text='Payment details'
                    variant="primary"
                    size='medium'
                    onClick={event => {
                      this.setState({ payInfoDialog: true });
                      event.stopPropagation();
                    }}
                  />
                </Grid> 
              </Grid>)
              :
              (<>
                <Grid item container xs={24} className="padding-b-20" alignItems="flex-start">
                  <Grid item xs={12} sm={10}>
                    <div className="fw-600 dialog-heading">
                      {formatDate(data.to_date, 'MMM, YYYY ')}
                    </div>
                    <div className="info-text light">
                Transaction period :
                      {` ${formatDate(
                        data.from_date,
                        'DD MMM, YYYY ',
                      )} - ${formatDate(data.to_date, 'DD MMM, YYYY ')}`}
                    </div>
                  </Grid>
                  <Grid item container xs={12} sm={14} justify="flex-end" alignItems="center">
                    <span
                      className={`status margin-r-10 font-16 ${remainingDaysObj.color}`}
                    >
                      {remainingDaysObj.text}
                    </span>
                    {this.props.currentBalance &&
                this.props.currentBalance.bill_id && (
                      <>
                        <span className="dot black margin-r-10"></span>
                        <span
                          className="status green pointer font-14"
                          onClick={this.changetoDetailView}
                        >
                  View details
                        </span>
                        <Icons
                          type="arrowbutton"
                          size="midium"
                          className="margin-l-10 status green pointer"
                          onClick={this.changetoDetailView}
                        />
                      </>
                    )}
                  </Grid>
                </Grid>
                {remainingDaysObj.warningMsg && (
                  <Grid item container xs={24} className="padding-b-20">
                    <div className={`status font-14 ${remainingDaysObj.color}`}>
                      {remainingDaysObj.warningMsg}
                    </div>
                  </Grid>
                )}
                <Grid container xs={24} alignItems="flex-start">
                  <Grid
                    item
                    xs={6}
                    direction="column"
                    justify="flex-start"
                  >
                    <Grid item>
                      <div className="info-text">Total payable </div>
                    </Grid>
                    <Grid item>
                      <div className="amount">
                        {currencyFormatter(data.payable_amount)}
                      </div>
                    </Grid>
                    <Grid item className="status">
                      {data.carryover_amount ? (
                      // <div className="info-text light">+ carried over</div>
                        <div>
                          <div className="info-text light">
                            {currencyFormatter(data.carryover_amount)} Carried
                      over
                          </div>
                          <div className="info-text light">
                            {currencyFormatter(data.billed_amount)} Current billed
                          </div>
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    direction="column"
                    justify="flex-start"
                    alignItems="flex-start"
                  >
                    <Grid item>
                      <div className="info-text">Due amount </div>
                    </Grid>
                    <Grid item>
                      <div className="font-24">
                        {currencyFormatter(data.remaining_balance)}
                      </div>
                    </Grid>
                    <Grid item className="status">
                      <span className="status green">
                        {currencyFormatter(data.total_paid)}
                      </span>
                      <span className="info-text light"> Payment received </span>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    direction="column"
                    justify="flex-start"
                    alignItems="flex-start"
                  >
                    <Grid item>
                      <div className="info-text">Due date </div>
                    </Grid>
                    <Grid item>
                      <div className="font-18 fw-600">
                        {formatDate(data.grace_period_end_date, 'DD MMM, YYYY ')}
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item xs={8} justify="flex-end" container alignItems="center">
                    {data.billed_transactions && data.billed_transactions.length ?
                      <BillExport
                        handleClick = {this.handleDownload}
                      />  : null
                    }
                    {data.status !== 'paid'? 
                      <Button
                        type="button"
                        text='Pay now'
                        variant="secondary"
                        size='medium'
                        className="margin-l-20"
                        onClick={event => {
                          this.setState({ payInfoDialog: true });
                          event.stopPropagation();
                        }}
                      />
                      : null
                    }
                  </Grid>
                </Grid>
              </>
              )}
          <PaymentInfo
            open={payInfoDialog}
            accData={this.props.verAccDetails}
            onPayInfoClose={value => {
              this.setState({ payInfoDialog: value });
            }}
          />
        </Grid>
        <Grid container item xs={24} className="margin-t-20">
          <Tabs
            tabName= {['Previous bill', 'Payments']} 
            onTabChange={this.handleChange}
            activeIndex={this.state.tab}
            isSmallView
            noBorder
            className= "white-bg full-width border-container-imp"
            tabStyle = {{fontSize:"14px", margin:"unset", padding:"10px 40px", minHeight:'48px'}}
          />
          <BalanceListView type={this.tabs[tab]} />
        </Grid>
      </Grid>
    );
  }
}

Bill.propTypes = {
  getCurrentBalance: PropTypes.func,
  currentBalance: PropTypes.object,
  clearBillStore: PropTypes.func,
  getVirtualAccDetails: PropTypes.func,
  verAccDetails: PropTypes.object,
  pdfCsvExcelDownload: PropTypes.func,
};
